module.exports = __webpack_public_path__ + "img/academy_tools-sm.9f46f548.png";